module.exports = __webpack_public_path__ + "static/media/header-1.f4e3efd2.png";